import { Box, Typography } from '@mui/material';

import { useContext, useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { colorVariables } from '@/constants';
import { SearchLayoutContext } from '@/page-components/Search/SearchLayout/SearchLayout';
import { ServicesLayoutContext } from '@/page-components/Services/ServicesLayout/ServicesLayout';
import { generateSearchEmptyMessage, generateServiceEmptyMessage } from '@/page-components/Search/EmptySearchResult/functions';

const EmptySearchResult = () => {
  const path = usePathname();
  const isSearch = path.includes('/hire');
  const { location, term } = useContext(SearchLayoutContext);
  const { currentCategory: servicesCurrentCategory } = useContext(ServicesLayoutContext);

  const message = useMemo(() => (isSearch
    ? generateSearchEmptyMessage(null, location, term)
    : generateServiceEmptyMessage(servicesCurrentCategory)
  ), [term, location, servicesCurrentCategory]);

  return (
    <Box
      height='100%'
      margin={3}
    >
      <Typography
        variant='h6'
        fontWeight={600}
      >
        {message}
      </Typography>

      <Typography
        variant='body1'
        fontWeight={400}
        marginTop={1}
        color={colorVariables.textDescription}
      >
        Please try another search.
      </Typography>
    </Box>
  );
};

export default EmptySearchResult;
